(() => {
  if (window.__equjumpMenuDrawerLoaded) return;
  window.__equjumpMenuDrawerLoaded = true;

  const submenuAnimations = new WeakMap();
  const getRoot = (element) => element?.closest?.('[data-eq-menu-drawer]');
  const reduceMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const closeDrawer = (root, restoreFocus = true) => {
    if (!root) return;

    const toggle = root.querySelector('[data-eq-menu-open]');
    const panel = root.querySelector('[data-eq-menu-panel]');

    root.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Abrir menú');
    panel?.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('[data-eq-menu-drawer].is-open')) {
      document.body.classList.remove('eq-menu-drawer-open');
    }

    if (restoreFocus) {
      window.setTimeout(() => toggle?.focus(), 20);
    }
  };

  const openDrawer = (root) => {
    if (!root) return;

    document.querySelectorAll('[data-eq-menu-drawer].is-open').forEach((openRoot) => {
      if (openRoot !== root) closeDrawer(openRoot, false);
    });

    const toggle = root.querySelector('[data-eq-menu-open]');
    const panel = root.querySelector('[data-eq-menu-panel]');
    const closeButton = root.querySelector('.eq-menu-drawer__close');

    root.classList.add('is-open');
    toggle?.setAttribute('aria-expanded', 'true');
    toggle?.setAttribute('aria-label', 'Cerrar menú');
    panel?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('eq-menu-drawer-open');

    window.setTimeout(() => closeButton?.focus(), 30);
  };

  const finishOpen = (submenu) => {
    submenu.classList.add('is-open');
    submenu.setAttribute('aria-hidden', 'false');
    submenu.style.display = 'block';
    submenu.style.height = 'auto';
    submenu.style.opacity = '';
    submenuAnimations.delete(submenu);
  };

  const finishClose = (submenu) => {
    submenu.classList.remove('is-open');
    submenu.setAttribute('aria-hidden', 'true');
    submenu.style.display = 'none';
    submenu.style.height = '0px';
    submenu.style.opacity = '';
    submenuAnimations.delete(submenu);
  };

  const openSubmenu = (button, submenu) => {
    submenuAnimations.get(submenu)?.cancel();

    button.setAttribute('aria-expanded', 'true');
    button.setAttribute(
      'aria-label',
      button.getAttribute('aria-label')?.replace(/^Abrir/, 'Cerrar') || 'Cerrar submenú'
    );

    submenu.classList.add('is-open');
    submenu.setAttribute('aria-hidden', 'false');
    submenu.style.display = 'block';
    submenu.style.height = 'auto';

    if (reduceMotion()) {
      finishOpen(submenu);
      return;
    }

    const targetHeight = submenu.scrollHeight;

    const animation = submenu.animate(
      [
        { height: '0px', opacity: 0 },
        { height: `${targetHeight}px`, opacity: 1 }
      ],
      {
        duration: 260,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      }
    );

    submenu.style.height = `${targetHeight}px`;
    submenuAnimations.set(submenu, animation);

    animation.onfinish = () => finishOpen(submenu);
    animation.oncancel = () => submenuAnimations.delete(submenu);
  };

  const closeSubmenu = (button, submenu) => {
    submenuAnimations.get(submenu)?.cancel();

    button.setAttribute('aria-expanded', 'false');
    button.setAttribute(
      'aria-label',
      button.getAttribute('aria-label')?.replace(/^Cerrar/, 'Abrir') || 'Abrir submenú'
    );

    submenu.setAttribute('aria-hidden', 'true');

    if (reduceMotion()) {
      finishClose(submenu);
      return;
    }

    const startHeight = submenu.scrollHeight;
    submenu.style.display = 'block';
    submenu.style.height = `${startHeight}px`;

    const animation = submenu.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: '0px', opacity: 0 }
      ],
      {
        duration: 240,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      }
    );

    submenuAnimations.set(submenu, animation);

    animation.onfinish = () => finishClose(submenu);
    animation.oncancel = () => submenuAnimations.delete(submenu);
  };

  const toggleSubmenu = (button) => {
    const submenuId = button.getAttribute('aria-controls');
    if (!submenuId) return;

    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeSubmenu(button, submenu);
    } else {
      openSubmenu(button, submenu);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      /* IMPORTANTE:
         Solo interceptamos la flecha. Los <a> navegan normalmente. */
      const submenuButton = event.target.closest('[data-eq-submenu-toggle]');

      if (submenuButton) {
        event.preventDefault();
        event.stopPropagation();
        toggleSubmenu(submenuButton);
        return;
      }

      const openButton = event.target.closest('[data-eq-menu-open]');

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();

        const root = getRoot(openButton);
        root?.classList.contains('is-open')
          ? closeDrawer(root)
          : openDrawer(root);
        return;
      }

      const closeButton = event.target.closest('[data-eq-menu-close]');

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeDrawer(getRoot(closeButton));
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openRoot = document.querySelector('[data-eq-menu-drawer].is-open');
    if (openRoot) closeDrawer(openRoot);
  });

  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('[data-eq-menu-drawer].is-open')) {
      document.body.classList.remove('eq-menu-drawer-open');
    }
  });
})();
